"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONVERSATION_AGENT_ROUTES = exports.CONVERSATION_AGENT_EVENTS = void 0;
/**
 * Shared WebSocket event names for conversation agent
 * These constants are used by both frontend and backend
 */
exports.CONVERSATION_AGENT_EVENTS = {
    USER_TRANSCRIPTION: 'user_transcription',
    AGENT_RESPONSE: 'agent_response',
    AGENT_STATUS: 'agent_status',
    CONVERSATION_AGENT_ERROR: 'conversation_agent_error',
    CONVERSATION_AGENT_ENDED: 'conversation_agent_ended',
    CONVERSATION_AGENT_STARTED: 'conversation_agent_started',
    AGENT_CONTEXT_UPDATED: 'agent_context_updated',
    AGENT_CONFIGURED: 'agent_configured',
    RECORDING_STOPPED: 'recording_stopped',
    AZURE_RESOURCE_CONSTRAINT: 'azure_resource_constraint',
    SESSION_TIMEOUT: 'session_timeout',
    TEXT_CHUNK_AUDIO_RESPONSE: 'text_chunk_audio_response'
};
/**
 * WebSocket route names for conversation agent endpoints
 * These constants are used for RWSRealtimeRoute decorators and sendMessage calls
 */
exports.CONVERSATION_AGENT_ROUTES = {
    START_CONVERSATION_AGENT: 'start_conversation_agent',
    SEND_AGENT_MESSAGE: 'send_agent_message',
    UPDATE_AGENT_CONTEXT: 'update_agent_context',
    CONFIGURE_AGENT: 'configure_agent',
    END_CONVERSATION_AGENT: 'end_conversation_agent',
    GET_AGENT_STATUS: 'get_agent_status',
    STOP_RECORDING: 'stop_recording',
    STREAM_TEXT_CHUNK: 'stream_text_chunk'
};
